/* global axios */
import ApiClient from '../ApiClient';

class ChatvidaWhatsappChannel extends ApiClient {
  constructor() {
    super('waha_inboxes', { accountScoped: true });
  }

  getSession(inboxId) {
    return axios.get(`${this.url}/${inboxId}`);
  }

  logout(inboxId) {
    return axios.post(`${this.url}/${inboxId}/logout`);
  }

  adopt(inboxId) {
    return axios.post(`${this.url}/${inboxId}/adopt`);
  }

  updateReceives(inboxId, receives) {
    return axios.patch(`${this.url}/${inboxId}`, { receives });
  }
}

export default new ChatvidaWhatsappChannel();
